const systemConfig = {
  s3: process.env.REACT_APP_CDN_STATIC,
  s3Docs: process.env.REACT_APP_CDN_DOC,
  banners: {
    arabic: "arabic.jpeg",
    english: "english.jpeg"
  },
  roles: [
    { value: "super_admin", label: "label_superadmins" },
    { value: "moderator", label: "label_stuffs" },
    { value: "support", label: "label_supervisors" },
    { value: "finance", label: "label_accountant" },
    { value: "showroom_admin", label: "label_showroom_staff" },
    { value: "realestate_admin", label: "label_realestate_staff" },
    { value: "auction_admin", label: "label_auction" }
  ],
  status: [
    { value: "all", label: "label_all" },
    { value: "active", label: "label_active" },
    { value: "disabled", label: "label_disabled" }
  ],
  statusAuctions: [
    { value: "all", label: "label_all" },
    { value: "pending", label: "label_pending" },
    { value: "confirmed", label: "label_confirmed" },
    { value: "active", label: "label_active" },
    { value: "expired", label: "label_expired" },
    { value: "canceled", label: "label_canceled" },
    { value: "sold", label: "label_sold" },
    { value: "notstarted", label: "label_not_started" },
  ],
  statusProviders: [
    { value: "ALL", label: "label_all" },
    { value: "CONFIRMED", label: "label_confirmed" },
    { value: "DISABLE", label: "label_disabled" },
    { value: "ACTIVATED", label: "label_active" }
  ],
  statusCustomers: [
    { value: "ALL", label: "label_all" },
    { value: "ACTIVE", label: "label_active" },
    { value: "CONFIRMED", label: "label_confirmed" },
    { value: "BLOCKED", label: "label_blocked" }
  ],
  statusStuffs: [
    { value: "all", label: "label_all" },
    { value: "PENDING", label: "label_pending" },
    { value: "CONFIRMED", label: "label_confirmed" },
    { value: "ACTIVE", label: "label_active" },
    { value: "DISABLED", label: "label_disabled" }
  ],
  statusRefunds: [
    { value: "ALL", label: "label_all" },
    { value: "PENDING", label: "label_pending" },
    { value: "VERIFIED", label: "label_verified" },
    { value: "REJECTED", label: "label_rejected" },
    { value: "CONFIRMED", label: "label_confirmed" },
    { value: "ACTIVE", label: "label_active" },
    { value: "NEED_VERIFICATION", label: "label_need_verification" },
    { value: "BLOCKED", label: "label_blocked" },
    { value: "NOT_VERIFIED", label: "label_rejected" }
  ],
  constraints: {
    password: {
      chars: ["lower", "upper", "numbers", "symbols"],
      passwordMinLength: 12
    }
  }
}

export const getRoles = (messages) =>
  systemConfig.roles.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatus = (messages) =>
  systemConfig.status.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatusAuction = (messages) =>
  systemConfig.statusAuctions.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatusForProviders = (messages) =>
  systemConfig.statusProviders.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatusCustomers = (messages) =>
  systemConfig.statusCustomers.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatusStuffs = (messages) =>
  systemConfig.statusStuffs.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export const getStatusRefunds = (messages) =>
  systemConfig.statusRefunds.map((item) => {
    return { value: item.value, label: messages[item.label] }
  })
export default systemConfig
